import { Pipe } from '@angular/core';
var SamplePipe = (function () {
    function SamplePipe() {
    }
    SamplePipe.prototype.transform = function (input, len) {
        if (len === void 0) { len = 1; }
        if (!Array.isArray(input)) {
            return input;
        }
        var sample = [];
        for (var i = 0, tmp = input.slice(), l = len < tmp.length ? len : tmp.length; i < l; ++i) {
            sample = sample.concat(tmp.splice(Math.floor(Math.random() * tmp.length), 1));
        }
        return sample;
    };
    return SamplePipe;
}());
export { SamplePipe };
SamplePipe.decorators = [
    { type: Pipe, args: [{ name: 'sample' },] },
];
/** @nocollapse */
SamplePipe.ctorParameters = function () { return []; };
//# sourceMappingURL=sample.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/sample.js
// module id = 209
// module chunks = 4